export const cgu = `<div class="page">
  <h1 class="title" data-reader-unique-id="titleElement">
    Gestion des cookies
  </h1>
  <p data-reader-unique-id="1">
    <strong data-reader-unique-id="2">PREAMBULE </strong>
  </p>
  <p data-reader-unique-id="3">
    La présente Charte de gestion des Cookies s’adresse aux utilisateurs
    (Ci-après les « Utilisateurs ») du présent site internet <a
      href="${location.origin}"
      data-reader-unique-id="4"
      ><strong data-reader-unique-id="5">${location.origin}</strong></a
    > (ci-après le « Site ») à savoir, toute personne qui accède et navigue sur
    le Site.
  </p>
  <p data-reader-unique-id="6">
    En acceptant le dépôt de cookies, vous consentez à ce que les cookies tels
    que décrits ci-dessous puissent être placés sur votre terminal conformément
    à la présente Charte de gestion des Cookies. Vous pouvez néanmoins à tout
    moment revenir sur votre consentement et refuser le dépôt de tel ou tel
    cookie.
  </p>
  <p data-reader-unique-id="7">
    <strong data-reader-unique-id="8">1. QUI COLLECTE MES DONNEES ? </strong>
  </p>
  <p data-reader-unique-id="9">
    Le responsable des traitements de données des Utilisateurs est WEEDEV,
    société par actions simplifiée au capital social de 1 021 285 euros,
    immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro
    912 448 974, dont le siège social est situé  114, rue Gallieni 92100 Boulogne-Billancourt
    (ci-après dénommée « WEEDEV », « Nous »).
  </p>
  <p data-reader-unique-id="10">
    <strong data-reader-unique-id="11">2. QU’EST-CE QU’UN COOKIE ? </strong>
  </p>
  <p data-reader-unique-id="12">
    Un cookie est un petit fichier texte déposé sur le disque dur de votre
    terminal lors de votre visite sur un site internet. Il enregistre certaines
    informations sur votre navigation ou sur votre comportement en ligne qui
    nous permettent d’améliorer et de faciliter votre expérience en qualité
    d’internaute.
  </p>
  <p data-reader-unique-id="13">
    <strong data-reader-unique-id="14">3. A QUOI SERVENT LES COOKIES ? </strong>
  </p>
  <p data-reader-unique-id="15">
    Les cookies utilisés sur le Site servent à vous différencier pour améliorer
    votre navigation et les services que nous vous proposons.
  </p>
  <p data-reader-unique-id="16">
    En pratique, les cookies techniques nous permettent de vous authentifier, de
    vous identifier, d’accélérer votre navigation sur notre Site et l’accès à
    ses différentes fonctionnalités. Ils peuvent, le cas échéant, enregistrer
    vos préférences ou mesurer les différents usages du Site.
  </p>
  <p data-reader-unique-id="17">
    D’autres cookies de mesure d’audience et traceurs peuvent nous servir à
    établir des statistiques d’audience de notre Site, afin de nous améliorer et
    de vous proposer toujours plus de confort dans la visite de notre Site.
  </p>
  <p data-reader-unique-id="18">
    <strong data-reader-unique-id="19"
      >4. LES COOKIES DU SITE ET LEUR FINALITE
    </strong>
  </p>
  <p data-reader-unique-id="20">
    WEEDEV privilégie la transparence dans le traitement de vos données. A
    ce titre, et pour que votre information soit la plus claire possible, vous
    trouverez ci-dessous différents cookies utilisés sur le Site et leur
    finalité :
  </p>
  <p data-reader-unique-id="21">
    <strong data-reader-unique-id="22"
      >4.1 Les cookies fonctionnels et techniques 
    </strong>
  </p>
  <p data-reader-unique-id="23">
    Ils permettent majoritairement d’améliorer votre navigation sur le Site. Ce
    sont eux qui vont envoyer des informations à notre Site et à votre
    navigateur : mémorisation des informations relatives à un formulaire
    (identifiant, adresse), les préférences d’affichage de votre terminal
    (langue, résolution), des mesures de sécurité comme l’expiration de votre
    session, etc.
  </p>
  <p data-reader-unique-id="24">
    <strong data-reader-unique-id="25">Nom du cookie</strong> :
    wp-wpml_current_language <br data-reader-unique-id="26" />Stocke la langue
    sélectionnée par l’utilisateur lors de sa visite
    <strong data-reader-unique-id="27"
      ><br data-reader-unique-id="28" />Durée</strong
    >
    1 an
  </p>
  <p data-reader-unique-id="29">
    <strong data-reader-unique-id="30">Nom du cookie</strong> :
    _icl_visitor_lang_js <br data-reader-unique-id="31" />Stocke la redirection
    vers la langue par défaut pour le contenu<br
      data-reader-unique-id="32"
    />‍<strong data-reader-unique-id="33">Durée</strong> 1 an
  </p>
  <p data-reader-unique-id="34">
    <strong data-reader-unique-id="35">Nom du cookie</strong> :
    wpml_browser_redirect_test <br data-reader-unique-id="36" />Référence pour
    tester l’activation ou non des cookies pour la partie tranduction du site
    <strong data-reader-unique-id="37"
      ><br data-reader-unique-id="38" />Durée</strong
    >
    1 an
  </p>
  <ul role="list" data-reader-unique-id="39">
    <li data-reader-unique-id="40">
      <a
        href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=fr"
        target="_blank"
        data-reader-unique-id="41"
        ><strong data-reader-unique-id="42"
          >Gérer les cookies dans Google Chrome</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="43">
      <a
        href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences"
        target="_blank"
        data-reader-unique-id="44"
        ><strong data-reader-unique-id="45"
          >Gérer les cookies dans Mozilla Firefox</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="46">
      <a
        href="https://privacy.microsoft.com/fr-fr/windows-10-microsoft-edge-and-privacy"
        target="_blank"
        data-reader-unique-id="47"
        ><strong data-reader-unique-id="48"
          >Gérer les cookies dans Edge</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="49">
      <a
        href="https://support.apple.com/kb/ph21411?locale=fr_CA"
        target="_blank"
        data-reader-unique-id="50"
        ><strong data-reader-unique-id="51"
          >Gérer les cookies dans Safari</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="52">
      <a
        href="http://help.opera.com/Windows/12.10/fr/extensions.html"
        target="_blank"
        data-reader-unique-id="53"
        ><strong data-reader-unique-id="54"
          >Gérer les cookies dans Opéra</strong
        ></a
      >
    </li>
  </ul>
  <p data-reader-unique-id="55">
    Attention, la navigation sur le Site et/ou l’utilisation de certaines
    fonctionnalités pourraient être altérées si vous choisissez de désactiver
    ces cookies.
  </p>
  <p data-reader-unique-id="56">
    <strong data-reader-unique-id="57"
      >4.2 Les cookies techniques de statistiques et de mesure d’audience du
      Site 
    </strong>
  </p>
  <p data-reader-unique-id="58">
    Ils nous aident à mieux comprendre l’utilisation qui est faite du Site et à
    vous proposer des services de qualité :
  </p>
  <p data-reader-unique-id="59">
    <strong data-reader-unique-id="60">Nom du cookie</strong> : _ga
    <br data-reader-unique-id="61" />Cookie pour l’unicité de l’utilisateur
    <br data-reader-unique-id="62" /><strong data-reader-unique-id="63"
      >Durée</strong
    >
    2 ans
  </p>
  <p data-reader-unique-id="64">
    ‍<br data-reader-unique-id="65" /><strong data-reader-unique-id="66"
      >Nom du cookie</strong
    >
    : _gid <br data-reader-unique-id="67" />Cookie pour l’unicité de
    l’utilisateur <br data-reader-unique-id="68" /><strong
      data-reader-unique-id="69"
      >Durée</strong
    >
    24 heures
  </p>
  <p data-reader-unique-id="70">
    <strong data-reader-unique-id="71">Nom du cookie</strong> : _gat
    <br data-reader-unique-id="72" />Cookie de pivot pour accélerer les
    requêttes <br data-reader-unique-id="73" /><strong
      data-reader-unique-id="74"
      >Durée</strong
    >
    1 minute
  </p>
  <p data-reader-unique-id="75">
     <strong data-reader-unique-id="76">Nom du cookie</strong> : _gac_<strong
      data-reader-unique-id="77"
      >{variable liée au compte google analytics}</strong
    >
    <br data-reader-unique-id="78" /> Cookie spécifique lié aux campagne de 
     recensement ou de publicité via le   compte Google Analytics
    <br data-reader-unique-id="79" /> <strong data-reader-unique-id="80"
      >Durée</strong
    >
    90 jours
  </p>
  <p>
  <strong>L’émission et/ou l’utilisation de cookies Google Analytics est soumise à sa propre politique et n’est pas donc pas couverte par la présente. La politique de Google Analytics en matière de cookies est disponible ici : <a href="https://marketingplatform.google.com/about/analytics/terms/fr/" target="blank" class="text-primary underline">Google Analytics</a> et <a href="https://business.safety.google/privacy/" target="blank" class="text-primary underline">Google Privacy</a></strong>
  </p>
  <ul role="list" data-reader-unique-id="81">
    <li data-reader-unique-id="82">
      <a
        href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=fr"
        target="_blank"
        data-reader-unique-id="83"
        ><strong data-reader-unique-id="84"
          >Gérer les cookies dans Google Chrome</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="85">
      <a
        href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences"
        target="_blank"
        data-reader-unique-id="86"
        ><strong data-reader-unique-id="87"
          >Gérer les cookies dans Mozilla Firefox</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="88">
      <a
        href="https://privacy.microsoft.com/fr-fr/windows-10-microsoft-edge-and-privacy"
        target="_blank"
        data-reader-unique-id="89"
        ><strong data-reader-unique-id="90"
          >Gérer les cookies dans Edge</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="91">
      <a
        href="https://support.apple.com/kb/ph21411?locale=fr_CA"
        target="_blank"
        data-reader-unique-id="92"
        ><strong data-reader-unique-id="93"
          >Gérer les cookies dans Safari</strong
        ></a
      >
    </li>
    <li data-reader-unique-id="94">
      <a
        href="http://help.opera.com/Windows/12.10/fr/extensions.html"
        target="_blank"
        data-reader-unique-id="95"
        ><strong data-reader-unique-id="96"
          >Gérer les cookies dans Opéra</strong
        ></a
      >
    </li>
  </ul>
  <p data-reader-unique-id="97">‍</p>
  <p data-reader-unique-id="98">
    <strong data-reader-unique-id="99">5. COMMENT GERER LES COOKIES ? </strong>
  </p>
  <p data-reader-unique-id="100">
    Sur vos ordinateurs, Smartphones et autres terminaux d’accès à Internet, par
    défaut le logiciel de navigation accepte les cookies présents sur les sites
    internet.
  </p>
  <p data-reader-unique-id="101">
    Mais vous restez maître de l’installation de ces cookies car vous avez la
    possibilité de configurer votre logiciel de navigation pour :
  </p>
  <p data-reader-unique-id="102">
    – Accepter ou refuser les cookies se trouvant sur le Site ;
  </p>
  <p data-reader-unique-id="103">
    – Refuser systématiquement tous les cookies ;
  </p>
  <p data-reader-unique-id="104">
    – Demander votre consentement sur chacun des cookies que vous rencontrez
    lors de votre navigation sur internet.
  </p>
  <p data-reader-unique-id="105">
    Pour ce faire, il vous suffit de vous reporter à vos logiciels de navigation
    et de suivre leurs instructions. A titre d’exemple :
  </p>
  <p data-reader-unique-id="106">
    – Avec <strong data-reader-unique-id="107">Internet Explorer</strong>™ :
    menu Outils ► Options internet ► Onglet Confidentialité ► choisissez le
    niveau souhaité
  </p>
  <p data-reader-unique-id="108">
    – Avec <strong data-reader-unique-id="109">Firefox</strong>™ : menu Outils ►
    Options ► Onglet Vie privée ► choisissez les options souhaitées
  </p>
  <p data-reader-unique-id="110">
    – Avec <strong data-reader-unique-id="111">Chrome</strong>™ : menu de
    configuration (logo paramètres) ► Paramètres ► Paramètres avancés ►
    Paramètres de contenu ► Choisissez les options souhaitées
  </p>
  <p data-reader-unique-id="112">
    – Avec <strong data-reader-unique-id="113">Safari</strong>™ : Safari (logo
    paramètres) ► Préférences ► Sécurité ► Afficher les cookies ► Choisissez les
    options souhaitées
  </p>
  <p data-reader-unique-id="114">
    – Avec <strong data-reader-unique-id="115">Opera</strong>™ : menu Outils ►
    Préférences ► Onglet Avancé ► Rubrique Cookies ► Gérer les cookies ►
    Choisissez les options souhaitées
  </p>
  <p data-reader-unique-id="116">
    <em data-reader-unique-id="117"
      >Comme indiqué précédemment, en choisissant de bloquer nos cookies, nous
      tenons à vous informer que la navigation sur le Site et/ou l’utilisation
      de certaines fonctionnalités pourraient être altérées. En tout état de
      cause, si vous choisissez de supprimer tous les cookies, votre expérience
      utilisateur en sera fortement affectée et vos préférences de navigation
      seront effacées.</em
    >
  </p>
  <p data-reader-unique-id="118">
    <strong data-reader-unique-id="119"
      >6. COMMENT GERER VOTRE CONSENTEMENT ?
    </strong>
  </p>
  <p data-reader-unique-id="120">
    En acceptant le dépôt de cookies, vous consentez à ce que WEEDEV
    installe des cookies dits « techniques » qui accèdent, inscrivent et
    consultent des informations stockées dans votre équipement terminal :
  </p>
  <p data-reader-unique-id="121">
    – Ayant pour finalité exclusive de permettre ou faciliter la communication
    par voie électronique ;
  </p>
  <p data-reader-unique-id="122">
    – Strictement nécessaires à la fourniture du service de communication en
    ligne du Site.
  </p>
  <p data-reader-unique-id="123">
    Lors de votre inscription sur le Site, vous avez également été informés de
    la présence de cookies traceurs destinés à réaliser des statistiques de
    visites et de la possibilité de vous y opposer en accédant à la présente
    Charte de gestion des cookies.
  </p>
  <p data-reader-unique-id="124">
    Dans tous les cas, vous êtes informés des finalités pour lesquelles vos
    données sont collectées par nos soins via les différents formulaires de
    collecte de données en ligne ou via notre Politique de confidentialité
    accessible sur la page suivante : <em data-reader-unique-id="125"
      ><a href="/politique_de_confidentialite" target="blank" class="text-primary underline">Politique de confidentialité</a></em
    >
  </p>
  <p data-reader-unique-id="126">
    Si le navigateur le permet, vous pouvez désactiver à tout moment ces
    cookies, en suivant la procédure indiquée par ce navigateur. Cependant,
    WEEDEV vous informe qu’une telle désactivation peut avoir pour
    conséquence de ralentir et/ou de perturber l’accès au Site.
  </p>

  <p data-reader-unique-id="128">
    <strong data-reader-unique-id="129">7. QUELS SONT VOS DROITS ? </strong>
  </p>
  <p data-reader-unique-id="130">
    Conformément à la Loi Informatique et Libertés n°78-17 du 6 janvier 1978 et
    au Règlement (UE) 2016/679 du parlement européen et du conseil du 27 avril
    2016, entré en vigueur le 25 mai 2018 (<em data-reader-unique-id="131"
      >ci-après « RGPD »</em
    >), vous disposez des droits suivants :
  </p>
  <ul role="list" data-reader-unique-id="132">
    <li data-reader-unique-id="133">
      Droit d’accès (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article15"
        target="_blank"
        data-reader-unique-id="134"
        >article 15 RGPD</a
      >), de rectification (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article16"
        target="_blank"
        data-reader-unique-id="135"
        >article 16 RGPD</a
      >), de mise à jour, de complétude de vos données ;
    </li>
    <li data-reader-unique-id="136">
      Droit de verrouillage ou d’effacement de vos données à caractère personnel
      (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17"
        target="_blank"
        data-reader-unique-id="137"
        >article 17 RGPD</a
      >), lorsqu’elles sont inexactes, incomplètes, équivoques, périmées, ou
      dont la collecte, l’utilisation, la communication ou la conservation est
      interdite ;
    </li>
  </ul>
  <ul role="list" data-reader-unique-id="138">
    <li data-reader-unique-id="139">
      Droit de retirer à tout moment votre consentement (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article13"
        target="_blank"
        data-reader-unique-id="140"
        >article 13-2c RGPD</a
      >) ;
    </li>
    <li data-reader-unique-id="141">
      Droit à la limitation du traitement de vos données (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article18"
        target="_blank"
        data-reader-unique-id="142"
        >article 18 RGPD</a
      >) ;
    </li>
    <li data-reader-unique-id="143">
      Droit d’opposition au traitement de vos données (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article21"
        target="_blank"
        data-reader-unique-id="144"
        >article 21 RGPD</a
      >) ;
    </li>
    <li data-reader-unique-id="145">
      Droit à la portabilité des données que vous nous avez fournies, lorsque
      vos données font l’objet de traitements automatisés fondés sur votre
      consentement ou sur un contrat (<a
        href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article20"
        target="_blank"
        data-reader-unique-id="146"
        >article 20 RGPD</a
      >) ;
    </li>
    <li data-reader-unique-id="147">
      Droit de définir le sort de vos données après votre mort et de choisir que
      nous communiquions (ou non) vos données à un tiers que vous aurez
      préalablement désigné.
    </li>
  </ul>
  <p data-reader-unique-id="148">
    En cas de décès et à défaut d’instructions de votre part, nous nous
    engageons à détruire vos données, sauf lorsque leur conservation s’avère
    nécessaire à des fins probatoires ou pour répondre à une obligation légale.
  </p>
  <p data-reader-unique-id="149">
    Vous pouvez exercer vos droits en utilisant l’un des moyens suivants :
  </p>
  <p data-reader-unique-id="150">
    – Soit par email, à l’adresse : <a
      href="mailto:dpo@hipto.com"
      target="_blank"
      data-reader-unique-id="151"
      >dpo@hipto.com</a
    >
  </p>
  <p data-reader-unique-id="152">
    – Soit par courrier à l’adresse suivante : DPO WEEDEV,  114, rue Gallieni 92100 Boulogne-Billancourt
  </p>
  <p data-reader-unique-id="153">
    Enfin, vous pouvez également introduire une réclamation auprès des autorités
    de contrôle et notamment de la CNIL (<a
      href="https://www.cnil.fr/fr/plaintes"
      target="_blank"
      data-reader-unique-id="154"
      >https://www.cnil.fr/fr/plaintes</a
    >).
  </p>
  <p data-reader-unique-id="155">
    En outre, si votre navigateur internet le permet, vous pouvez à tout moment
    désactiver ces cookies en vous référant aux procédures détaillées ci-avant.
  </p>
  <p data-reader-unique-id="156">
    Pour en savoir plus sur notre gestion de vos données à caractère personnel,
    consultez notre Politique de confidentialité accessible sur la page
    suivante : <em data-reader-unique-id="157"
      ><a href="/politique_de_confidentialite" target="blank" class="text-primary underline">Politique de confidentialité</a></em
    >
  </p>
  <p data-reader-unique-id="158">
    <strong data-reader-unique-id="159">8. DUREES DE CONSERVATION </strong>
  </p>
  <p data-reader-unique-id="160">
    En tout état de cause, les informations stockées dans votre terminal (ex :
    cookies) ou tout autre élément utilisé pour vous identifier à des fins de
    statistiques d’audience ne sont pas conservés au-delà d’une période de
    treize (13) mois. Au-delà de ce délai, les données de fréquentation brutes
    associées à un identifiant sont soit supprimées soit anonymisées.
  </p>
  <p data-reader-unique-id="161">
    Pour en savoir plus sur les cookies (comment les gérer, les supprimer, les
    identifier), vous pouvez consulter le site internet de la CNIL : <a
      href="https://www.cnil.fr/vos-droits/vos-traces/les-cookies/#c5554"
      target="_blank"
      data-reader-unique-id="162"
      >http://www.cnil.fr/vos-droits/vos-traces/les-cookies/#c5554</a
    >.
  </p>

  <p data-reader-unique-id="165">Dernière mise à jour: Septembre 2024</p>
  <h2 data-reader-unique-id="166">‍</h2>
  <h4 data-reader-unique-id="167"></h4>
  <p data-reader-unique-id="168">‍</p>
</div>
`;
